// const BASE_URL = "https://api.pickeat.fr";
const BASE_URL = "https://brewdex-api.gery.me";

export const SIGN_UP_URL = BASE_URL + '/api/auth/register';
export const SIGN_IN_URL = BASE_URL + '/api/auth/login';